<template lang="pug">
.bloco-dados-tabs-mapa-monitoramento-agricola
    h2 {{ $t('mensagens.monitoramentoAgricola.blocoMapa.titulo') }}

    .bloco-acuracia(v-if='dados.culturaSelecionada === "SOJA"')
        el-row.info-container
            el-col(:span='8')
                el-row
                    el-col(:span='4')
                        .legenda-acuracia(:style='{ background: "#63AF01" }')
                    el-col(:span='20')
                        div
                            span.titulo-legenda-acuracia {{ dados.culturaSelecionada }}
                        div
                            span.subtitulo-legenda-acuracia Acurácia maior que 80%

            el-col(:span='8')
                el-row
                    el-col(:span='4')
                        .legenda-acuracia(:style='{ background: "#889306" }')
                    el-col(:span='20')
                        div
                            span.titulo-legenda-acuracia {{ dados.culturaSelecionada }}
                        div
                            span.subtitulo-legenda-acuracia Acurácia entre 51% e 80%
            el-col(:span='8')
                el-row
                    el-col(:span='4')
                        .legenda-acuracia(:style='{ background: "#D6D951" }')
                    el-col(:span='20')
                        div
                            span.titulo-legenda-acuracia {{ dados.culturaSelecionada }}
                        div
                            span.subtitulo-legenda-acuracia Acurácia menor que 50%

        //-----AREA PLANTADA
        el-row.info-container
            el-col(:span='8')
                el-row
                    el-col(:span='24')
                        div
                            span.label-info {{ $t('mensagens.monitoramentoAgricola.blocoMapa.areaPlantada') }}
                        div
                            span.info {{ formatters.formatNumber(dadosAcuracia['acuracia_maior_80']?.areaHa, 2) || '-' }} ha

            el-col(:span='8')
                el-row
                    el-col(:span='24')
                        div
                            span.label-info {{ $t('mensagens.monitoramentoAgricola.blocoMapa.areaPlantada') }}
                        div
                            span.info {{ formatters.formatNumber(dadosAcuracia['acuracia_51_80']?.areaHa, 2) || '-' }} ha
            el-col(:span='8')
                el-row
                    el-col(:span='24')
                        div
                            span.label-info {{ $t('mensagens.monitoramentoAgricola.blocoMapa.areaPlantada') }}
                        div
                            span.info {{ formatters.formatNumber(dadosAcuracia['acuracia_menor_50']?.areaHa, 2) || '-' }} ha

        //-----PRODUTIVIDADE
        el-row.info-container
            el-col(:span='8')
                el-row
                    el-col(:span='24')
                        div
                            span.label-info {{ $t('mensagens.monitoramentoAgricola.blocoMapa.produtividadeEstimada') }}
                        div
                            span.info {{ formatters.formatProdutividade(dadosAcuracia['acuracia_maior_80']?.produtividade) || '-' }} {{ dados.culturaSelecionada === 'ALGODAO' ? ' @/ha' : ' sc/ha' }}

            el-col(:span='8')
                el-row
                    el-col(:span='24')
                        div
                            span.label-info {{ $t('mensagens.monitoramentoAgricola.blocoMapa.produtividadeEstimada') }}
                        div
                            span.info {{ formatters.formatProdutividade(dadosAcuracia['acuracia_51_80']?.produtividade) || '-' }} {{ dados.culturaSelecionada === 'ALGODAO' ? ' @/ha' : ' sc/ha' }}
            el-col(:span='8')
                el-row
                    el-col(:span='24')
                        div
                            span.label-info {{ $t('mensagens.monitoramentoAgricola.blocoMapa.produtividadeEstimada') }}
                        div
                            span.info {{ formatters.formatProdutividade(dadosAcuracia['acuracia_menor_50']?.produtividade) || '-' }} {{ dados.culturaSelecionada === 'ALGODAO' ? ' @/ha' : ' sc/ha' }}

        //-----DATA PLANTADA
        el-row.info-container
            el-col(:span='8')
                el-row
                    el-col(:span='24')
                        div
                            span.label-info {{ $t('mensagens.monitoramentoAgricola.blocoMapa.inicioPlantio') }}
                        div
                            span.info {{ formatData(dadosAcuracia['acuracia_maior_80']?.dataPlantio) || '--/--/--' }}

            el-col(:span='8')
                el-row
                    el-col(:span='24')
                        div
                            span.label-info {{ $t('mensagens.monitoramentoAgricola.blocoMapa.inicioPlantio') }}
                        div
                            span.info {{ formatData(dadosAcuracia['acuracia_51_80']?.dataPlantio) || '--/--/--' }}
            el-col(:span='8')
                el-row
                    el-col(:span='24')
                        div
                            span.label-info {{ $t('mensagens.monitoramentoAgricola.blocoMapa.inicioPlantio') }}
                        div
                            span.info {{ formatData(dadosAcuracia['acuracia_menor_50']?.dataPlantio) || '--/--/--' }}

    .separator.info-container(v-if='dados.culturaSelecionada === "SOJA"')

    //-----INFO GERAL
    el-row.info-container
        el-col(:span='24')
            el-row
                el-col(:span='24')
                    div
                        span.label-info {{ $t('mensagens.monitoramentoAgricola.blocoMapa.areaTotalPlantada') }}
                    div
                        span.info {{ formatters.formatNumber(areaTotalPlantada, 2) || '-' }} ha

    el-row.info-container
        el-col(:span='12')
            el-row
                el-col(:span='24')
                    div
                        span.label-info {{ $t('mensagens.monitoramentoAgricola.blocoMapa.inicioPlantio') }}
                    div
                        span.info {{ dados.dataInicioPlantio || '--/--/--' }}
        el-col(:span='12')
            el-row
                el-col(:span='24')
                    div
                        span.label-info {{ $t('mensagens.monitoramentoAgricola.blocoMapa.previsaoColheita') }}
                    div
                        span.info {{ dados.dataPrevisaoColheita || '--/--/--' }}

    el-row.info-container
        el-col(:span='12')
            el-row
                el-col(:span='24')
                    div
                        span.label-info {{ $t('mensagens.monitoramentoAgricola.blocoMapa.areaColhida') }}
                    div
                        span.info {{ formatters.formatNumber(dados.areaColhida, 2) || '-' }} ha
        el-col(:span='12')
            el-row
                el-col(:span='24')
                    div
                        span.label-info {{ $t('mensagens.monitoramentoAgricola.blocoMapa.produtividadeEstimada') }}
                    div
                        span.info {{ formatters.formatRoundProdutividade(estimativaMediaProdutividade) }} {{ dados.culturaSelecionada === 'ALGODAO' ? ' @/ha' : ' sc/ha' }}
    //-----BARRA DE PROGRESSO
    el-row
        el-col(:span='24')
            span.label-info {{ $t('mensagens.monitoramentoAgricola.evolucaoColheita') }}

    el-row.progresso-dados
        el-col(:span='12')
            span.info {{ dados.evolucaoArea.colhido }}
        el-col.progresso-dados-fim(:span='12')
            span.info {{ dados.evolucaoArea.pendente }}

    el-row
        el-progress(
            :text-inside='true',
            :show-text='false',
            :stroke-width='20',
            :percentage='dados.evolucaoArea.percentualColhido ? dados.evolucaoArea.percentualColhido : 0',
            color='var(--secondary-two)'
        )
</template>

<script>
import formatters from '@/utils/formatters';
import MonitoramentoAgricolaService from '@/services/MonitoramentoAgricolaService';

export default {
    name: 'BlocoDadosTabsMapaMonitoramentoAgricola',
    props: {
        dados: {
            type: Object,
            required: false
        }
    },
    async created() {
        await this.buscarAcuracia();
    },
    data() {
        return {
            formatters,
            dadosAcuracia: {},
            areaTotalPlantada: '',
            estimativaMediaProdutividade: ''
        };
    },
    watch: {
        dados: async function () {
            await this.buscarAcuracia();
        }
    },
    methods: {
        formatAreaHa(areaHa) {
            if (!areaHa) {
                return '0 ha';
            }

            return `${formatters.formatNumberUs(areaHa)} ha`;
        },

        formatData(data) {
            if (!data) return null;
            return data.split('-').reverse().join('/');
        },

        async buscarAcuracia() {
            try {
                this.carregando = true;
                const idArea = this.$route.params.id;
                const { data } =
                    await MonitoramentoAgricolaService.buscarAcuraciaMonitoramento(
                        idArea,
                        this.dados.culturaSelecionada
                    );

                const entre50e80 = data.produtividades.filter(
                    item => item.codigoAcuracia === 'DE_51_A_80'
                );
                const menor50 = data.produtividades.filter(
                    item => item.codigoAcuracia === 'MENOR_50'
                );
                const maior80 = data.produtividades.filter(
                    item => item.codigoAcuracia === 'MAIOR_80'
                );

                this.dadosAcuracia = {
                    acuracia_menor_50: menor50[0],
                    acuracia_51_80: entre50e80[0],
                    acuracia_maior_80: maior80[0]
                };

                this.areaTotalPlantada = this.dados.areaPlantada;

                this.estimativaMediaProdutividade = 0;
                if (this.dados.culturaSelecionada !== 'OUTROS') {
                    this.estimativaMediaProdutividade =
                        data.estimativaMediaProdutividade;
                }

                this.carregando = false;
            } catch {
                this.$notify.error({
                    message: 'Ocorreu um erro ao buscar as áreas monitoradas'
                });
            }
        }
    }
};
</script>

<style lang="scss">
.bloco-dados-tabs-mapa-monitoramento-agricola {
    h2 {
        font-size: 16px;
        color: #3b3b3b;
        font-weight: 600;
        margin-bottom: 20px;
    }

    .bloco-acuracia {
        width: 100%;
    }

    .titulo-legenda-acuracia {
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        padding-left: 5px;

        color: #3b3b3b;

        flex: none;
        order: 1;
        flex-grow: 0;
    }

    .subtitulo-legenda-acuracia {
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 300;
        font-size: 12px;
        line-height: 16px;
        padding-left: 5px;

        color: #3b3b3b;

        flex: none;
        order: 1;
        flex-grow: 0;
    }

    .separator {
        width: 100%;
        height: 0px;

        border: 1px solid #d9d9d9;

        flex: none;
        order: 1;
        align-self: stretch;
        flex-grow: 0;
        flex-grow: 0;
        margin: 20px 0px 25px 0px;
    }

    .bloco-dados-acuracia {
        height: 80%;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .legenda-acuracia {
        width: 3.5vh;
        height: 3.5vh;
        border-radius: 5px;
        margin-right: 5px;
    }

    .label-info {
        font-family: Roboto;
        font-size: 14px;
        font-weight: 400;
        line-height: 14px;
        letter-spacing: 0px;
        text-align: left;
        color: #3b3b3b;
    }

    .info {
        font-family: Roboto;
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;
        letter-spacing: 0em;
        text-align: left;
        color: #00413c;
    }

    .info-container {
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
    }

    .progresso-dados {
        display: flex;
        justify-content: space-between;
    }

    .progresso-dados-fim {
        display: flex;
        justify-content: flex-end;
    }
}
</style>
